"use client"

import { ApertureStyles, T, FM, MAXW, SectionEyebrow } from "./_shared"

export default function ApertureIndustryStats() {
  // Volume + waste angle — complements the Problem section above which
  // covers reputation. Stats kept to one-line claims with a real source
  // so engineers don't dismiss the numbers as marketing fluff.
  const facts = [
    { v: "22.5%",   l: "of your contacts go stale every year",       src: "HubSpot"   },
    { v: "3%",      l: "is the bounce rate Gmail starts throttling at", src: "Validity"  },
    { v: "$0.005+", l: "wasted per send to a dead inbox",            src: "Mailchimp" },
  ]
  return (
    <section className="relative">
      <ApertureStyles />
      <div className={`${MAXW} mx-auto px-6 lg:px-10 py-12 sm:py-16 md:py-24`}>
        <SectionEyebrow>The math</SectionEyebrow>
        <h2
          className="mt-3 leading-[1.0] tracking-[-0.035em] max-w-3xl"
          style={{ fontSize: "clamp(2rem, 4.4vw, 3.4rem)", fontWeight: 800 }}
        >
          Bad addresses cost twice.{" "}
          <em style={{ color: T.acc, fontStyle: "italic", fontWeight: 700 }}>Once in spend, once in trust.</em>
        </h2>
        <p className="mt-5 max-w-[60ch]" style={{ fontSize: 15.5, color: T.ink2, lineHeight: 1.55 }}>
          You pay your ESP per email — sent or bounced. Then you pay again in sender
          reputation: throttled deliverability for the next campaign, then the one after
          that. Email is the channel that compounds — both directions.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-10 mt-14">
          {facts.map((f, i) => (
            <div key={f.l} className="pt-6" style={{ borderTop: `1px solid ${T.ink}` }}>
              <p
                className="tabular-nums"
                style={{
                  fontSize: "clamp(2.4rem, 4.2vw, 3.4rem)",
                  fontWeight: 800,
                  letterSpacing: "-0.04em",
                }}
              >
                {f.v}
              </p>
              <p className="mt-3 max-w-[28ch]" style={{ fontSize: 15, color: T.ink2, lineHeight: 1.5 }}>
                {f.l}
              </p>
              <p
                className="mt-5 inline-flex items-center gap-1.5"
                style={{ fontFamily: FM, fontSize: 11, color: T.ink3, letterSpacing: "0.06em" }}
              >
                <span style={{ color: T.acc }}>↳</span> Source: {f.src}
                <span style={{ color: T.ink4 }}>·</span> [{String(i + 1).padStart(2, "0")}]
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
